/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationStateType } from './OrganizationStateType';
import {
    OrganizationStateTypeFromJSON,
    OrganizationStateTypeFromJSONTyped,
    OrganizationStateTypeToJSON,
} from './OrganizationStateType';

/**
 * 
 * @export
 * @interface OrganizationStateTownSwitchTypeRequest
 */
export interface OrganizationStateTownSwitchTypeRequest {
    /**
     * 
     * @type {OrganizationStateType}
     * @memberof OrganizationStateTownSwitchTypeRequest
     */
    type?: OrganizationStateType;
}

/**
 * Check if a given object implements the OrganizationStateTownSwitchTypeRequest interface.
 */
export function instanceOfOrganizationStateTownSwitchTypeRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrganizationStateTownSwitchTypeRequestFromJSON(json: any): OrganizationStateTownSwitchTypeRequest {
    return OrganizationStateTownSwitchTypeRequestFromJSONTyped(json, false);
}

export function OrganizationStateTownSwitchTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationStateTownSwitchTypeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : OrganizationStateTypeFromJSON(json['type']),
    };
}

export function OrganizationStateTownSwitchTypeRequestToJSON(value?: OrganizationStateTownSwitchTypeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': OrganizationStateTypeToJSON(value.type),
    };
}

